module.exports = __webpack_public_path__ + "static/media/Jerry Biji Mathew.2060a743.jpg";